export const blockIconsSocialWorkspacesNew = (
	<span className='material-symbols-outlined'>workspaces</span>
);
